export function scheduleIdle(callback) {
  if (typeof window.requestIdleCallback === 'function') {
    const idle = window.requestIdleCallback(callback, {timeout: 2000});
    return () => window.cancelIdleCallback(idle);
  }
  const timer = window.setTimeout(callback, 200);
  return () => window.clearTimeout(timer);
}

// Wait for the browser to report its first contentful frame before background
// work. Two animation frames alone can run before that frame is presented.
// Callers can cancel this schedule when user interaction needs the work sooner.
export function scheduleAfterPaint(callback) {
  let frame;
  let cancelIdle;
  let observer;
  let scheduled = false;
  let cancelled = false;
  const run = () => { if (!cancelled) callback(); };
  const schedule = () => {
    if (cancelled || scheduled) return;
    scheduled = true;
    observer?.disconnect();
    cancelIdle = scheduleIdle(run);
  };
  const fallback = () => {
    if (typeof window.requestAnimationFrame !== 'function') return schedule();
    frame = window.requestAnimationFrame(() => {
      frame = window.requestAnimationFrame(schedule);
    });
  };
  if (window.PerformanceObserver?.supportedEntryTypes?.includes('paint')) {
    try {
      observer = new window.PerformanceObserver(list => {
        if (list.getEntries().some(entry => entry.name === 'first-contentful-paint')) schedule();
      });
      observer.observe({type: 'paint', buffered: true});
    } catch {
      observer?.disconnect();
      fallback();
    }
  } else {
    fallback();
  }
  return () => {
    cancelled = true;
    observer?.disconnect();
    if (frame !== undefined) window.cancelAnimationFrame(frame);
    cancelIdle?.();
  };
}
